class HeroCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.hero-carousel__track');
    this.slides = Array.from(this.querySelectorAll('.hero-carousel__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-carousel__dot'));
    this.currentIndex = 0;

    if (!this.track || this.slides.length < 2) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    this.track.addEventListener('scroll', this.debounce(this.onScroll.bind(this), 80));

    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.speed || '5', 10) * 1000;

    if (this.autoplay) {
      this.startAutoplay();
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }

    this.updateDots();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onScroll() {
    const slideWidth = this.track.clientWidth;
    const index = Math.round(this.track.scrollLeft / slideWidth);
    if (index !== this.currentIndex) {
      this.currentIndex = index;
      this.updateDots();
    }
  }

  goToSlide(index) {
    const slideWidth = this.track.clientWidth;
    this.track.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
    this.currentIndex = index;
    this.updateDots();
  }

  updateDots() {
    this.dots.forEach((dot, index) => {
      const isCurrent = index === this.currentIndex;
      // Per spec: hollow = current slide, filled = other slides
      dot.setAttribute('aria-current', isCurrent ? 'true' : 'false');
    });
  }

  startAutoplay() {
    if (!this.autoplay) return;
    this.stopAutoplay();
    this._interval = setInterval(() => {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this._interval) clearInterval(this._interval);
  }
}

customElements.define('hero-carousel', HeroCarousel);
